import React from 'react';

export const WarningIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
	<svg width='800px' height='800px' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
		<g data-name='3. Danger' id='_3._Danger'>
			<path
				fill='#77acf1'
				d='M10,1h6a0,0,0,0,1,0,0V6.13a.87.87,0,0,1-.87.87H10.87A.87.87,0,0,1,10,6.13V1A0,0,0,0,1,10,1Z'
			/>
			<path
				fill='#04009a'
				d='M11,26H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H23a3,3,0,0,1,3,3v9a1,1,0,0,1-2,0V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V23a1,1,0,0,0,1,1h8a1,1,0,0,1,0,2Z'
			/>
			<path fill='#04009a' d='M7,22H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z' />
			<path
				fill='#04009a'
				d='M28.6,32H15.4a3.39,3.39,0,0,1-3-5l5.76-10.7h0a4.35,4.35,0,0,1,7.66,0L31.59,27a3.39,3.39,0,0,1-3,5ZM19.93,17.23,14.17,27.94A1.39,1.39,0,0,0,15.4,30H28.6a1.39,1.39,0,0,0,1.23-2.06L24.07,17.23a2.36,2.36,0,0,0-4.14,0Z'
			/>
			<path fill='#77acf1' d='M22,24a1,1,0,0,1-1-1V20a1,1,0,0,1,2,0v3A1,1,0,0,1,22,24Z' />
			<path fill='#77acf1' d='M22,28a1,1,0,1,1,0-2h0a1,1,0,0,1,0,2Z' />
		</g>
	</svg>
);
